import React from 'react';
import { Button, IconButton, ButtonProps, IconButtonProps } from '@mui/material';
import { usePermissions } from '../../../contexts/PermissionsContext';

interface PermissionButtonProps extends Omit<ButtonProps, 'action'> {
  module: string;
  permissionAction: 'add' | 'edit' | 'delete' | 'execute' | 'manage';
  fallbackPermission?: string; // Custom permission to check instead of module_action_scr
}

interface PermissionIconButtonProps extends Omit<IconButtonProps, 'action'> {
  module: string;
  permissionAction: 'add' | 'edit' | 'delete' | 'execute' | 'manage';
  fallbackPermission?: string; // Custom permission to check instead of module_action_scr
}

/**
 * Button component that only renders if user has the required permission
 */
export const PermissionButton: React.FC<PermissionButtonProps> = ({
  module,
  permissionAction,
  fallbackPermission,
  ...buttonProps
}) => {
  const { hasActionPermission, hasPermission } = usePermissions();

  // Check custom permission first, then module-based permission
  const hasRequiredPermission = fallbackPermission
    ? hasPermission(fallbackPermission)
    : hasActionPermission(module, permissionAction);

  if (!hasRequiredPermission) {
    return null;
  }

  return (
    <Button {...buttonProps} />
  );
};

/**
 * Icon button component that only renders if user has the required permission
 */
export const PermissionIconButton: React.FC<PermissionIconButtonProps> = ({
  module,
  permissionAction,
  fallbackPermission,
  ...buttonProps
}) => {
  const { hasActionPermission, hasPermission } = usePermissions();

  // Check custom permission first, then module-based permission
  const hasRequiredPermission = fallbackPermission
    ? hasPermission(fallbackPermission)
    : hasActionPermission(module, permissionAction);

  if (!hasRequiredPermission) {
    return null;
  }

  return (
    <IconButton {...buttonProps} />
  );
};

export default PermissionButton;